// extracted by mini-css-extract-plugin
export var FadeSlideshow = "FadeSlideshow-module--FadeSlideshow--kvvvC";
export var aniSpin = "FadeSlideshow-module--ani-spin--7QqOy";
export var counter = "FadeSlideshow-module--counter--jFsd0";
export var image = "FadeSlideshow-module--image--Z+x4m";
export var navigate = "FadeSlideshow-module--navigate--O8N5W";
export var preload__images = "FadeSlideshow-module--preload__images--FMEd-";